<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
      <span class="logo-mini">
        <a href="/">
          <img
            src="/static/img/logo_cmyk_colour.svg"
            alt="Logo"
            class="img-responsive center-block logo"
          >
        </a>
      </span>

      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle hidden" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <Clientmenu :Ddata="lookupdata"></Clientmenu>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!-- Messages-->
            <li class="dropdown messages-menu" style="display:none;">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-envelope-o"></i>
                <span class="label label-success">{{ userInfo.messages | count }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.messages | count }} message(s)</li>
                <li v-if="userInfo.messages.length > 0">
                  <!-- inner menu: contains the messages -->
                  <ul class="menu">
                    <li>
                      <!-- start message -->
                      <a href="javascript:;">
                        <!-- Message title and timestamp -->
                        <h4>
                          Support Team
                          <small>
                            <i class="fa fa-clock-o"></i> 5 mins
                          </small>
                        </h4>
                        <!-- The message -->
                        <p>Why not consider this a test message?</p>
                      </a>
                    </li>
                    <!-- end message -->
                  </ul>
                  <!-- /.menu -->
                </li>
                <li class="footer" v-if="userInfo.messages.length > 0">
                  <a href="javascript:;">See All Messages</a>
                </li>
              </ul>
            </li>
            <!-- /.messages-menu -->
            <!-- Notifications Menu -->
            <li class="dropdown notifications-menu" style="display:none;">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-bell-o"></i>
                <span class="label label-warning">{{ userInfo.notifications | count }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.notifications | count }} notification(s)</li>
                <li v-if="userInfo.notifications.length > 0">
                  <!-- Inner Menu: contains the notifications -->
                  <ul class="menu">
                    <li>
                      <!-- start notification -->
                      <a href="javascript:;">
                        <i class="fa fa-users text-aqua"></i> 5 new members joined today
                      </a>
                    </li>
                    <!-- end notification -->
                  </ul>
                </li>
                <li class="footer" v-if="userInfo.notifications.length > 0">
                  <a href="javascript:;">View all</a>
                </li>
              </ul>
            </li>

            <!-- Tasks Menu -->
            <li class="dropdown tasks-menu" style="display:none;">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="fa fa-flag-o"></i>
                <span class="label label-danger">{{ userInfo.tasks | count }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ userInfo.tasks | count }} task(s)</li>
                <li v-if="userInfo.tasks.length > 0">
                  <!-- Inner menu: contains the tasks -->
                  <ul class="menu">
                    <li>
                      <!-- Task item -->
                      <a href="javascript:;">
                        <!-- Task title and progress text -->
                        <h3>
                          Design some buttons
                          <small class="pull-right">20%</small>
                        </h3>
                        <!-- The progress bar -->
                        <div class="progress xs">
                          <!-- Change the css width attribute to simulate progress -->
                          <div
                            class="progress-bar progress-bar-aqua"
                            style="width: 20%"
                            role="progressbar"
                            aria-valuenow="20"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          >
                            <span class="sr-only">20% Complete</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <!-- end task item -->
                  </ul>
                </li>
                <li class="footer" v-if="userInfo.tasks.length > 0">
                  <a href="javascript:;">View all tasks</a>
                </li>
              </ul>
            </li>

            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <!-- The user image in the navbar-->
                <img v-bind:src="demo.avatar" class="user-image" alt="User Image">
                <!-- hidden-xs hides the username on small devices so only the image appears. -->
                <span class="hidden-xs">{{ demo.displayName }}</span>
              </a>
              <ul class="dropdown-menu usermenu">
                <li>
                  <a href="#" v-on:click="logout()">Logoff</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.avatar"/>

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          {{ $route.meta.description }}
          <!--           {{$route.name.toUpperCase() }}
          <small>{{ $route.meta.description }}</small>-->
        </h1>
        <ol class="breadcrumb">
          <li>
            <a href="javascript:;">
              <i class="fa fa-home"></i>Home
            </a>
          </li>
          <li class="active">{{$route.meta.description.toUpperCase()}}</li>
        </ol>
      </section>

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->
    <!-- Main Footer -->
    <footer class="main-footer">
      <strong>
        Copyright &copy; {{year}}
        <a href="http://data2decisions.com/">data2decisions</a>.
      </strong> All rights reserved.
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import 'hideseek'
import Clientmenu from '../components/views/clientmenu'
import jQuery from 'jquery'
export default {
  name: 'Dash',
  components: {
    Sidebar,
    Clientmenu
  },
  data: function () {
    return {
      // section: 'Dash',
      SpinerSize: '180px',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: '',
      lookupdata: []
    }
  },
  mounted () {
    if (
      window.localStorage.getItem('user') === 'null' ||
      window.localStorage.length === 0
    ) {
      this.$router.push('/login')
    } else {
      this.getData()
    }
  },
  computed: {
    ...mapState(['userInfo']),
    demo () {
      var usern
      if (
        localStorage.getItem('name') !== undefined ||
        localStorage.getItem('name') !== null
      ) {
        usern = localStorage.getItem('name')
      } else {
        usern = localStorage.getItem('email')
      }
      return {
        displayName: usern,
        avatar: '/static/img/stock/user.png',
        email: localStorage.getItem('email'),
        randomCard: ''
      }
    }
  },
  methods: {
    getData () {
      var self = this
      jQuery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/GetLookupTable',
        data: {},
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
        },
        complete: function () {
          // jQuery('.dataspinner').show()
          this.isLoadingcompo = false
          self.$pingpong.hideloader()
        },
        success: function (data) {
          data = JSON.parse(data['lookup-data'])
          self.lookupdata = data
          console.log(self.res)
          // self.displaypopup()
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
          self.displaydownloadError()
        }
      })
    },
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    logout () {
      this.$parent.logout()
    }
  }
}
</script>

<style lang="scss">
.content-wrapper {
  margin-top: 50px;
}
.wrapper {
  min-height: 100vh !important;
}
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
    min-height: 90vh;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;

  img {
    padding: 0.4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
.content-wrapper,
.right-side {
  background-color: #fff;
}
.bg-green,
.callout.callout-success,
.alert-success,
.label-success,
.modal-success .modal-body {
  background-color: #9fc54c;
}
.alert-success {
  width: 97.5%;
  margin: 10px auto;
  border-color: #9fc54c;
}

.pageLink .router-link-exact-active,
.skin-blue .sidebar-menu > li > a.router-link-exact-active {
  color: #fff;
  background: #0e8eae;
  border-left-color: #9fc54c;
  border-left: 3px solid #9fc54c;
}

.usermenu {
  width: 100% !important;
  background: #9fc54c;
  li a {
    color: #fff !important;
    font-weight: bold;
    &:hover {
      background-color: #444;
    }
  }
}

h4 small {
  font-size: 60% !important;
}
.btn-primary:hover,
.btn-primary:active,
.btn-primary.hover,
.btn-primary:focus,
.btn-primary.active.focus,
.btn-primary.active:focus,
.btn-primary.active:hover,
.btn-primary:active.focus,
.btn-primary:active:focus,
.btn-primary:active:hover,
.open > .dropdown-toggle.btn-primary.focus,
.open > .dropdown-toggle.btn-primary:focus,
.open > .dropdown-toggle.btn-primary:hover {
  border-color: #9fc54c;
  background-color: #9fc54c;
  outline: none;
}
.vgt-loading__content {
  background-color: transparent !important;
  .spinner:before {
  }
  .spinner {
    display: block;
  }
}
.spinner {
  margin: 50px auto 0;
  width: 70px;
  text-align: center;
  position: absolute;
  left: 50%;
  right: auto;
  top: 10%;
  bottom: 50%;
  z-index: 9999;
  display: none;
}

.spinner::before {
  position: fixed;
  height: 200vh;
  width: 200vw;
  /* left: -100%; */
  right: 0;
  top: 0;
  content: ' ';
  display: block;
  background: rgba(00, 00, 00, 0.7);
  pointer-events: none;
  z-index: 99999;
}
.spinner,
.dataspinner {
  margin: 50px auto 0;
  width: 70px;
  text-align: center;
  position: absolute;
  left: 50%;
  right: auto;
  top: 10%;
  bottom: 50%;
  z-index: 9999;
}

.spinner > div,
.dataspinner > div {
  width: 18px;
  height: 18px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
canvas {
  transition: all 0.35s ease-in-out;
}
.spinner .bounce1,
.dataspinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2,
.dataspinner .bounce12 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
.table > caption + thead > tr:first-child > td,
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > td,
.table > thead:first-child > tr:first-child > th {
  border-top: 1px solid #ddd;
}
table.table-bordered th:last-child,
table.table-bordered td:last-child {
  border-right-width: 1px;
}
.dataspinner {
  margin: 0 auto 0;
  left: calc(50% - 70px);
  top: 1px;
  bottom: 0;
  z-index: 9999;
}
.dataspinner {
  display: none;
}
.vgt-loading {
  margin-top: 0 !important;
}
.dataspinner::after {
  position: fixed;
  height: 100%;
  width: 100%;
  /* left: -100%; */
  right: 0;
  top: 0;
  content: ' ';
  display: block;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 99;
}

.dataspinner span {
  display: block;
  width: 182px;
  color: #9fc54c;
  font-size: 30px;
  margin-left: -70%;
  text-shadow: 0px 0px 5px rgba(150, 150, 150, 0.4);
}

.dataspinner > div {
  background-color: #9fc54c;
}
.vgt-inner-wrap.is-loading {
  opacity: 0.1 !important;
}
.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
}

.content-header>.breadcrumb{
  font-size: 14px
}
</style>



// WEBPACK FOOTER //
// Dash.vue?0c039873